var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-play-container",style:({width:_vm.width?_vm.width+'px':'100%',height:_vm.height?_vm.height+'px':'100%'})},[_c('d-player',{ref:"player",attrs:{"id":"player","options":_vm.options}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }